"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.membersSelector = exports.fetchMembers = exports.updateRoleForMemberSuccess = exports.getMembersFailure = exports.getMembersSuccess = exports.getMembers = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var lodash_1 = require("lodash");
var apiService_1 = __importDefault(require("@common/services/apiService"));
var initialState = {
    data: null,
    loading: false,
    error: null,
};
var internalEmailDomains = ['@besedo.com', '@iosquare.com'];
var getIsInternalUser = function (email) {
    return internalEmailDomains.some(function (emailDomain) { return email.indexOf(emailDomain) !== -1; });
};
var processMembers = function (members, currentUserEmail) {
    var isCurrentUserFromBesedo = getIsInternalUser(currentUserEmail);
    return (0, lodash_1.sortBy)(members.filter(function (member) {
        member.isCurrentUser = currentUserEmail === member.email;
        if (isCurrentUserFromBesedo) {
            return true; // if current logged-in user is from Besedo, display all members
        }
        // if current logged-in user is NOT from Besedo, do not display Besedo members
        return !getIsInternalUser(member.email);
    }), 'nextReminderAt');
};
var members = (0, toolkit_1.createSlice)({
    name: 'members',
    initialState: initialState,
    reducers: {
        getMembers: function (state) {
            state.loading = true;
        },
        getMembersSuccess: function (state, _a) {
            var payload = _a.payload;
            var members = payload.members, currentUserEmail = payload.currentUserEmail;
            state.data = processMembers(members, currentUserEmail).sort(function (a, b) {
                if (a.isCurrentUser) {
                    return -1;
                }
                if (b.isCurrentUser) {
                    return 1;
                }
                return a.hierarchy - b.hierarchy;
            });
            state.loading = false;
            state.error = null;
        },
        getMembersFailure: function (state, _a) {
            var payload = _a.payload;
            state.loading = false;
            state.error = payload;
        },
        updateRoleForMemberSuccess: function (state, _a) {
            var payload = _a.payload;
            var email = payload.email, roleId = payload.roleId;
            if (state.data) {
                state.data = state.data.map(function (member) {
                    if (member.email === email) {
                        return __assign(__assign({}, member), { roleId: roleId });
                    }
                    return member;
                });
            }
        },
    },
});
exports.getMembers = (_a = members.actions, _a.getMembers), exports.getMembersSuccess = _a.getMembersSuccess, exports.getMembersFailure = _a.getMembersFailure, exports.updateRoleForMemberSuccess = _a.updateRoleForMemberSuccess;
function fetchMembers(domain, currentUserEmail) {
    var _this = this;
    return (function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch((0, exports.getMembers)());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiService_1.default.getMembers({ domain: domain })];
                case 2:
                    data = (_a.sent()).data;
                    dispatch((0, exports.getMembersSuccess)({ members: data, currentUserEmail: currentUserEmail }));
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    if (error_1 instanceof Error) {
                        dispatch((0, exports.getMembersFailure)(error_1.message));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); });
}
exports.fetchMembers = fetchMembers;
exports.default = members.reducer;
var membersSelector = function (state) { return state.currentTeam.settings.members.data; };
exports.membersSelector = membersSelector;
